import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['form', 'element', 'address', 'messages', 'button', 'buttonSpinner', 'buttonText'];
  static values = { intent: String, key: String, url: String, addressMode: { type: String, default: "" } };

  initialize() {
    const stripe = Stripe(this.keyValue);
    const appearance = {
      theme: 'stripe',
    };

    this.elements = stripe.elements({
      appearance: appearance,
      clientSecret: this.intentValue,
    });
    const paymentElement = this.elements.create('payment');
    paymentElement.mount(this.elementTarget);

    if (this.addressModeValue !== "" && this.hasAddressTarget) {
      const addressElement = this.elements.create("address", {
        mode: this.addressModeValue
      });
      addressElement.mount(this.addressTarget);
    }

    this.formTarget.addEventListener('submit', async (event) => {
      event.preventDefault();

      this.buttonTarget.setAttribute('disabled', '');
      this.buttonTextTarget.classList.add("hidden");
      this.messagesTarget.classList.add("hidden");
      this.buttonSpinnerTarget.classList.remove("hidden");

      const { error } = await stripe.confirmPayment({
        //`Elements` instance that was used to create the Payment Element
        elements: this.elements,
        confirmParams: {
          return_url: this.urlValue,
        },
      });

      if (error) {
        this.buttonTarget.removeAttribute('disabled', '');
        this.buttonSpinnerTarget.classList.add("hidden");
        this.buttonTextTarget.classList.remove("hidden");

        // console.log("STRIPE error:", error)

        // This point will only be reached if there is an immediate error when
        // confirming the payment. Show error to your customer (for example, payment
        // details incomplete)
        this.messagesTarget.textContent = error.message;
        this.messagesTarget.classList.remove("hidden");
      } else {
        // Your customer will be redirected to your `return_url`. For some payment
        // methods like iDEAL, your customer will be redirected to an intermediate
        // site first to authorize the payment, then redirected to the `return_url`.
      }
    });

    paymentElement.on('ready', (event) => {
      this.buttonTarget.removeAttribute('disabled', '');
      this.buttonSpinnerTarget.classList.add("hidden");
      this.buttonTextTarget.classList.remove("hidden");
    });
  }
}
